import { menuselect_solution } from "@/constant/menuselect";

let str = "业务概述";
export const config = {
  title: "单体医院",
  headerInfo:
    "敬在信息医院综合运营管理信息系统从一开始就是一体化设计研发。不但能够满足医院当前的经济管理方面的需求，更可以随着医院业务以及管理需要的发展和变化，不断与其它系统扩充和整合。最终构建起整个医院的以会计核算为核心、以预算管理为主线、以成本核算、物流和固定资产管理为基础、以医院经营决策为目标，以绩效考核为杠杆，将医院的人、财、物信息高度集成的综合运营管理平台(HRP)。",
  headerImg: require("@/assets/images/single_hospital/Rectangle19header.svg"),
  activeSubTitle: str,
  navList: [
    {
      name: "单体医院",
      children: menuselect_solution(),
    },
    {
      name: "业务概述",
      desc: " ",
      tabList: [{}],
      [str]: [
        {
          title: "",
          desc: "单体医院的综合运营管理系统建设，其涉及到医院管理的方方面面，必须从一开始就针对全院相关业务环节整体设计，才能够满足未来医院建设完成综合运营决策平台的目标，避免出现信息孤岛。敬在信息医院综合运营管理信息系统从一开始就是一体化设计研发。不但能够满足医院当前的经济管理方面的需求，更可以随着医院业务以及管理需要的发展和变化，不断与其它系统扩充和整合。最终构建起整个医院的以会计核算为核心、以预算管理为主线、以成本核算、物流和固定资产管理为基础、以医院经营决策为目标，以绩效考核为杠杆，将医院的人、财、物信息高度集成的综合运营管理平台(HRP)。",
          img: require("@/assets/images/single_hospital/Frame 214.svg"),
        },
        {
          title: "价值亮点",
          desc: " ",
          img: require("@/assets/images/single_hospital/Frame 1138.svg"),
        },
        {
          title: "管理价值",
          desc: " ",
          img: require("@/assets/images/single_hospital/Group 788.svg"),
        },
      ],
    },
    {
      name: "建设目标",
      desc: " ",
      tabList: [{}],
      [str]: [
        {
          title: "",
          desc: "单体医院的综合运营管理系统建设，其涉及到医院管理的方方面面，必须从一开始就针对全院相关业务环节整体设计，才能够满足未来医院建设完成综合运营决策平台的目标，避免出现信息孤岛。敬在信息医院综合运营管理信息系统从一开始就是一体化设计研发。不但能够满足医院当前的经济管理方面的需求，更可以随着医院业务以及管理需要的发展和变化，不断与其它系统扩充和整合。最终构建起整个医院的以会计核算为核心、以预算管理为主线、以成本核算、物流和固定资产管理为基础、以医院经营决策为目标，以绩效考核为杠杆，将医院的人、财、物信息高度集成的综合运营管理平台(HRP)。",
          img: require("@/assets/images/single_hospital/Frame 214.svg"),
        },
        {
          title: "价值亮点",
          desc: " ",
          img: require("@/assets/images/single_hospital/Frame 1138.svg"),
        },
        {
          title: "管理价值",
          desc: " ",
          img: require("@/assets/images/single_hospital/Group 788.svg"),
        },
      ],
    },
    {
      name: "管理价值",
      desc: " ",
      tabList: [{}],
      [str]: [
        {
          title: "",
          desc: "单体医院的综合运营管理系统建设，其涉及到医院管理的方方面面，必须从一开始就针对全院相关业务环节整体设计，才能够满足未来医院建设完成综合运营决策平台的目标，避免出现信息孤岛。敬在信息医院综合运营管理信息系统从一开始就是一体化设计研发。不但能够满足医院当前的经济管理方面的需求，更可以随着医院业务以及管理需要的发展和变化，不断与其它系统扩充和整合。最终构建起整个医院的以会计核算为核心、以预算管理为主线、以成本核算、物流和固定资产管理为基础、以医院经营决策为目标，以绩效考核为杠杆，将医院的人、财、物信息高度集成的综合运营管理平台(HRP)。",
          img: require("@/assets/images/single_hospital/Frame 214.svg"),
        },
        {
          title: "价值亮点",
          desc: " ",
          img: require("@/assets/images/single_hospital/Frame 1138.svg"),
        },
        {
          title: "管理价值",
          desc: " ",
          img: require("@/assets/images/single_hospital/Group 788.svg"),
        },
      ],
    },
  ],
};
